module.exports = __webpack_public_path__ + "static/lines_hero-ec6120b616fcf6c9d9e96f114907e407.jpg";